<template>
  <div>
    <span class="theme--light mr-2">Menge</span>
    <v-btn icon @click="decrement" :disabled="count <= min"><v-icon>mdi-minus</v-icon></v-btn>{{ count }}
    <v-btn icon @click="increment" :disabled="count >= max"><v-icon>mdi-plus</v-icon></v-btn>
  </div>
</template>

<script>
export default {
name: "OrderAmount",
  data: () => ({
    count: 0
  }),
  props:['price', 'min', 'max'],
  computed: {
    total() {
      return this.price * this.count;
    }
  },
  watch: {
    total(newValue) {
      this.$emit('change', {count: this.count, total: newValue});
    }
  },
  mounted() {
    this.count = parseInt(this.min);
    //this.emitEvent();
  },
  methods: {
    increment() {
      this.count++;
    },
    decrement() {
      this.count--;
    },
  }
}
</script>

<style scoped>
</style>
